NodeList.prototype._remove = function () {
  this.forEach(element => {
    element.parentNode.removeChild(element);
  });
};

NodeList.prototype._isNodeList = HTMLCollection.prototype._isNodeList = function () {
  return true;
};